import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import logo from "assets/images/footerLogo.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetNewPassword, setNewPassword, validateUUID } from "store/actions/authSlice";
import { showAlert } from "store/reducers/alertReducer";
import Spinners from "components/common/Spinners";
import { Form, Formik } from "formik";
import { newPasswordSchema } from "components/common/Validation";
import { newPasswordValues } from "components/constants/InitialFormValues";
import CustomLabel from "components/common/CustomLabel";
import CustomField from "components/common/CustomField";

const ResetNewPassword = () => {
  const { t } = useTranslation();
  document.title = t("Reset New Password | Work Space");

  const { uuid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { isLoading } = useSelector((state) => state.auth);

  const [uuidValidateInfo, setUuidValidateInfo] = useState({});

  const handleNewPassword = async (values, { resetForm }) => {
    const { newPassword, confirmPassword } = values;

    // Get values from localStorage
    const organisation_id = localStorage.getItem("organisation_id");
    const invitation_token = localStorage.getItem("invitation_token");

    const payload = {
      id: organisation_id,
      token: invitation_token,
      newPassword,
      confirmPassword,
    };

    dispatch(setNewPassword(payload))
      .then((action) => {
        const { statusCode, success, message } = action?.payload || {};
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          localStorage.removeItem("organisation_id");
          localStorage.removeItem("invitation_token");
          navigate("/dashboards/overview");
          resetForm();
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch(() => {});
  };

  if (loading) return <Spinners />;

  return (
    <div className="login_page">
      <div className="login_form g_center">
        <div className="w-100">
          <img src={logo} width={65} height={72} alt="Work Space Logo" />
          <h1>{t("Set Password")}</h1>
          <Formik
            initialValues={newPasswordValues}
            enableReinitialize={true}
            validationSchema={newPasswordSchema}
            onSubmit={handleNewPassword}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="form_field">
                  <CustomLabel
                    htmlFor="newPassword"
                    label={t("New Password")}
                  />
                  <CustomField
                    name="newPassword"
                    type="password"
                    placeholder={t("Enter new password")}
                    touched={touched}
                    errors={errors}
                  />
                </div>
                <div className="form_field">
                  <CustomLabel
                    htmlFor="confirmPassword"
                    label={t("Confirm password")}
                  />
                  <CustomField
                    name="confirmPassword"
                    type="password"
                    placeholder={t("Confirm password")}
                    touched={touched}
                    errors={errors}
                  />
                </div>
                <button
                  type="submit"
                  className="primary_btn w-100"
                  disabled={isLoading}
                >
                  {t("Reset")}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ResetNewPassword;
